<!--
 * @Author: yuanjianlong
 * @Description: 组件展示
 * @Date: 2021-12-01 11:19:24
 * @LastEditTime: 2022-03-24 10:43:55
 * @FilePath: /teacher-h5/src/demo/Button.vue
-->
<template>
  <div class="h-full p-20 bg-gray-10">
    <div class="components-button">
      <h1 class="text-h32">
        按钮 Button
      </h1>
      <div class="components-button-list">
        <div class="mb-20">
          <h1>重要按钮</h1>
          <a-button type="primary" size="small" class="btn-primary">
            Primary small
          </a-button>
          <a-button type="primary" class="btn-primary">
            Primary defalut
          </a-button>
          <a-button type="primary" size="large" class="btn-primary">
            Primary large
          </a-button>
          <a-button type="primary" size="large" class="btn-primary btn-primary-disabled" disabled>
            Primary large
          </a-button>
        </div>
        <div class="mb-20">
          <h1>常用按钮</h1>
          <a-button size="small">
            Btn small
          </a-button>
          <a-button>
            Btn defalut
          </a-button>
          <a-button size="large">
            Btn large
          </a-button>
          <a-button size="large" disabled>
            Btn large
          </a-button>
        </div>
        <div class="mb-20">
          <h1>次要按钮</h1>
          <a-button size="small" type="dashed">
            Dashed small
          </a-button>
          <a-button type="dashed">
            Dashed defalut
          </a-button>
          <a-button size="large" type="dashed">
            Dashed large
          </a-button>
          <a-button size="large" disabled type="dashed">
            Dashed large
          </a-button>
        </div>
        <div class="mb-20">
          <h1>文字按钮</h1>
          <a-button size="small" type="link">
            link small
          </a-button>
          <a-button type="link">
            link defalut
          </a-button>
          <a-button size="large" type="link">
            link large
          </a-button>
          <a-button size="large" disabled type="link">
            link large
          </a-button>
        </div>
        <div class="mb-20">
          <h1>链接按钮</h1>
          <a-button size="small" class="link" type="link">
            link small
          </a-button>
          <a-button type="link" class="link">
            link defalut
          </a-button>
          <a-button size="large" type="link" class="link">
            link large
          </a-button>
          <a-button size="large" disabled type="link" class="link">
            link large
          </a-button>
        </div>
        <div class="mb-20">
          <h1>警示按钮</h1>
          <a-button type="danger" @click="onClick">
            Danger
          </a-button>
          <a-button type="danger" disabled>
            Danger
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClick() {
      this.$logger.sendLogById('jzx-teacher_2')
      this.$logger.sendAmcLog({
        aad: 'jzx-teacher_3',
        pp1: {
          classId: 1
        }
      })
    }
  }
}
</script>

<style>
.mb-20 {
  margin-bottom: 20px;
}
</style>